<script lang="ts">
  import { get, readable } from "svelte/store"
  import { setContext, hasContext, createEventDispatcher, onMount, getContext } from "svelte"
  if (!getContext("isAuthorized")) {
    setContext("isAuthorized", {
      isAuthorized: readable("isAuthorized", (set) => {
        set(() => true)
      }),
      fetchPolicies: () => true,
    })
  }
  import { Router, Route } from "svelte-routing"
  import { ChannelsCreate, CompositorsCreate, CompositorsDetail, CompositorsIndex, CopyjobsDetail, CopyjobsIndex, CopymanagersCreate, CopymanagersDetail, CopymanagersIndex, DestinationsCreate, DestinationsDetail, DestinationsIndex, JobsDetail, JobsIndex, LocationsCreate, LocationsDetail, LocationsIndex, OpenApi, Page404 } from "./pages/index.js"
  import en from "./i18n/en.json"
  import de from "./i18n/de.json"
  import { addMessages, init } from "svelte-i18n"
  import ChannelsDetail from "./pages/channels/ChannelsDetail.svelte"
  import ChannelsIndex from "./pages/channels/ChannelsIndex.svelte"
  import Home from "./pages/Home.svelte"
  import { callout, config as configStore } from "./stores/index"
  import { api } from "./services"
  import "./app.css"
  import { FormTheme, Loader } from "@gl/design-system"
  import FilesIndex from "./pages/files/FilesIndex.svelte"
  import FilesDetail from "./pages/files/FilesDetail.svelte"
  import loadConfig from "./services/config.js"
  import type { Config, Contract, User } from "./services/models.js"

  const { fetchPolicies } = getContext("isAuthorized")

  const dispatch = createEventDispatcher()

  export let language: string;
  export let basepath: string;
  export let apiurl: string;
  export let user: User;
  export let contract: Contract;
  export let repositories: object;
  export let isStandalone: boolean = false;


  hasContext("FormTheme") || setContext("FormTheme", FormTheme)

  addMessages("en", en)
  addMessages("de", de)
  init({ fallbackLocale: "en", initialLocale: language })

  setContext("language", language ?? "en")

  $: if ($callout) {
    dispatch("callout", { callout: $callout })
  }

  async function configure() {
    // TODO: Switch of contract passed from global fe
    await loadConfig({language, basepath, apiurl, user, contract, repositories, isStandalone})

    let config: Config = get(configStore)
    language = config.language
    basepath = config.basePath
    api.init(config.apiUrl)
  }

  onMount(() => {
    fetchPolicies()
  })
</script>
{#await configure()}
<Loader/>
{:then}
<Router {basepath}>
  <Route path="/contracts/:CON/" component={Home} />
  <Route path="/contracts/:CON/openapi" component={OpenApi} />
  <Route path="/contracts/:CON/home" component={Home} />
  <Route path="/contracts/:CON/jobs" component={JobsIndex} />
  <Route path="/contracts/:CON/jobs/:uuid" component={JobsDetail} />
  <Route path="/contracts/:CON/files" component={FilesIndex} />
  <Route path="/contracts/:CON/files/:uuid" component={FilesDetail} />
  <Route path="/contracts/:CON/channels" component={ChannelsIndex} />
  <Route path="/contracts/:CON/channels/create" component={ChannelsCreate} />
  <Route path="/contracts/:CON/channels/patch/:uuid" component={ChannelsCreate} />
  <Route path="/contracts/:CON/channels/:uuid" component={ChannelsDetail} />
  <Route path="/contracts/:CON/locations" component={LocationsIndex} />
  <Route path="/contracts/:CON/locations/create" component={LocationsCreate} />
  <Route path="/contracts/:CON/locations/patch/:uuid" component={LocationsCreate} />
  <Route path="/contracts/:CON/locations/:uuid" component={LocationsDetail} />
  <Route path="/contracts/:CON/compositors" component={CompositorsIndex} />
  <Route path="/contracts/:CON/compositors/create" component={CompositorsCreate} />
  <Route path="/contracts/:CON/compositors/patch/:uuid" component={CompositorsCreate} />
  <Route path="/contracts/:CON/compositors/:uuid" component={CompositorsDetail} />
  <Route path="/contracts/:CON/copymanagers" component={CopymanagersIndex} />
  <Route path="/contracts/:CON/copymanagers/create" component={CopymanagersCreate} />
  <Route path="/contracts/:CON/copymanagers/patch/:uuid" component={CopymanagersCreate} />
  <Route path="/contracts/:CON/copymanagers/:uuid" component={CopymanagersDetail} />
  <Route path="/contracts/:CON/destinations" component={DestinationsIndex} />
  <Route path="/contracts/:CON/destinations/create" component={DestinationsCreate} />
  <Route path="/contracts/:CON/destinations/patch/:uuid" component={DestinationsCreate} />
  <Route path="/contracts/:CON/destinations/:uuid" component={DestinationsDetail} />
  <Route path="/contracts/:CON/copyjobs" component={CopyjobsIndex} />
  <Route path="/contracts/:CON/copyjobs/:uuid" component={CopyjobsDetail} />
  <Route component={Page404} />
</Router>
{/await}